import axios from 'axios';
import FormData from 'form-data';
import config from '../config/appConfig';

axios.defaults.withCredentials = true;

const init = async () => {
  const { data } = await axios.post(`${config.api}/init`);

  return data;
};

const login = async ({ email, password }) => {
  const { data } = await axios.post(`${config.api}/login`, { email, password });

  return data;
};

const firebaseLogin = async ({ idToken }) => {
  const { data } = await axios.post(`${config.api}/firebase-auth`, { idToken });

  return data;
};

const logout = async () => {
  await axios.post(`${config.api}/logout`);
};

const register = async registerData => {
  const { data } = await axios.post(`${config.api}/register`, registerData);

  return data;
};

const addCompanyPayData = data => axios.post(`${config.api}/pay`, data);
const expireCompany = data => axios.post(`${config.api}/expire`, data);

const getPaidCompanyList = () => axios.get(`${config.api}/get-paid-companies`);

const checkDomain = domain =>
  axios.get(`${config.api}/check-domain?domain=${domain}`);

const getCompanyMetaData = async ({ companyId }) => {
  const { data } = await axios.get(
    `${config.api}/get-company-meta-data?companyId=${companyId}`
  );
  return data;
};
const getCompanyIdDetails = async companyId => {
  const { data } = await axios.get(`${config.api}/sales/company/${companyId}`);
  return data;
};

const getCompanyKycData = async ({ companyId }) => {
  const { data } = await axios.get(
    `${config.api}/sales/payment-gateway/kyc?companyId=${companyId}`
  );
  return data;
};

const toggleVerifyCompanyKycData = async formData => {
  const { data } = await axios.put(
    `${config.api}/sales/payment-gateway/toggle`,
    formData
  );
  return data;
};

const getSalesType = async companyId => {
  const { data } = await axios.get(
    `${config.api}/sales/sales-type/${companyId}`
  );
  return data;
};

const getSalesPersonEmail = async () => {
  const { data } = await axios.get(`${config.api}/sales/sales-person-emails`);
  return data;
};

const getEstimate = async formData => {
  const { data } = await axios.post(
    `${config.api}/sales/upgrade-payment-link/estimate`,
    formData
  );
  return data;
};

const generateLink = async formData => {
  const { data } = await axios.post(
    `${config.api}/sales/payment-link`,
    formData
  );
  return data;
};

const generateUpgradeLink = async formData => {
  const { data } = await axios.post(
    `${config.api}/sales/upgrade-payment-link`,
    formData
  );
  return data;
};

const getFilterDetails = async () => {
  const { data } = await axios.get(
    `${config.api}/catalogues/catalogue-search-filters`
  );
  return data;
};

const downloadCatalogue = async optionsSelected => {
  const { data } = await axios.post(
    `${config.api}/catalogues/search-catalogue-pdf`,
    optionsSelected
  );
  return data;
};
const getCataloguesData = async finalData => {
  const { data } = await axios.post(
    `${config.api}/catalogues/filtered-catalogues`,
    finalData
  );
  return data;
};

const getLinkValidityDetails = async paymentLink => {
  const { data } = await axios.get(
    `${config.api}/sales/payment-link/${paymentLink}`
  );
  return data;
};

const savePaymentLink = async ({ paymentLink, ...updates }) => {
  const { data } = await axios.patch(
    `${config.api}/sales/payment-link/${paymentLink}`,
    updates
  );
  return data;
};

const uploadCompanyLogo = async ({ logoSelected, companyId }) => {
  const logoData = new FormData();
  logoData.append('logoSelected', logoSelected);
  const { data } = await axios.post(
    `${config.api}/upload-company-logo?companyId=${companyId}`,
    logoData
  );

  return data;
};

const getExperimentsData = async companyId => {
  // const { data } = await axios.get(`${config.api}/company-experiments/<companyId>/landingPage?companyId=${companyId}`);
  const { data } = await axios.get(
    `${config.api}/get-mandatory-login?companyId=${companyId}`
  );
  return data;
};

const setMandatoryLogin = async (companyId, value) => {
  console.log('companyId, value', companyId, value);
  const { data } = await axios.post(`${config.api}/set-mandatory-login`, {
    companyId,
    value
  });
  return data;
  // const { data } = await axios.post(
  //   `${config.api}/set-mandatory-login?companyId=${companyId}`,
  //   value
  // );
  // console.log('data', data);
};

const setPaymentGatewayShown = async (companyId, value) => {
  console.log('companyId, value', companyId, value);
  const { data } = await axios.post(`${config.api}/set-payment-gateway-shown`, {
    companyId,
    value
  });
  return data;
};

const setPrivacyModuleActive = async (companyId, value) => {
  console.log('companyId, value', companyId, value);
  const { data } = await axios.post(`${config.api}/set-privacy-module-active`, {
    companyId,
    value
  });
  return data;
};

const setResellerGroupCreation = async (companyId, value) => {
  const { data } = await axios.post(
    `${config.api}/set-reseller-group-creation`,
    {
      companyId,
      value
    }
  );
  return data;
};

const setGrtVendor = async (companyId, value) => {
  const { data } = await axios.post(`${config.api}/set-grt-vendor`, {
    companyId,
    value
  });
  return data;
};

const saveCompanyFeedback = async ({ companyId, type, feedback }) => {
  const { data } = await axios.post(`${config.api}/cs/company-feedback`, {
    companyId,
    type,
    feedback
  });
  return data;
};

const getLastPayment = async ({ companyId }) => {
  const { data } = await axios.get(
    `${config.api}/cs/company-last-payment?companyId=${companyId}`
  );
  return data;
};

const getNotificationKeyData = async key => {
  const { data } = await axios.get(
    `${config.api}/notification/data?key=${key}`
  );
  return data;
};

const sendNotification = async payload => {
  const { data } = await axios.post(`${config.api}/notification`, payload);
  return data;
};

const getCompanyIdFromRemote = async (key, value) => {
  const { data } = await axios.get(
    `${config.api}/sales/get-company-id?${key}=${encodeURIComponent(value)}`
  );
  return data;
};

const getCompanyPitchFromRemote = async companyId => {
  const { data } = await axios.get(
    `${config.api}/sales/sales-jetpack?companyId=${companyId}`
  );
  return data;
};

const validateRequestLead = async () => {
  const { data } = await axios.get(
    `${config.api}/sales/request-leads/validate`
  );
  return data;
};

const assignMoreLeads = async () => {
  const { data } = await axios.post(`${config.api}/sales/request-leads/assign`);
  return data;
};

const generateEmandateLink = async formData => {
  return axios.post(`${config.api}/sales/emandate-link/v2`, formData);
};

const createChargebeeCustomer = companyId =>
  axios.post(`${config.api}/sales/create-chargebee-customer`, { companyId });

const getDoubleTickOrganizationDetails = async phone => {
  const phoneWithPrefix = `+91${phone}`;
  const { data } = await axios.get(
    `${config.api}/sales/doubletick-org-details`,
    {
      params: {
        phone: phoneWithPrefix
      }
    }
  );
  return data;
};

const getSecureLead = async leadId => {
  const { data } = await axios.get(`${config.api}/leads/${leadId}`);
  return data;
};

const createRazorpaySmartCollectId = async razorpaySmartCollectData => {
  const { data } = await axios.post(
    `${config.api}/doubletick/plan/setup-enterprise`,
    razorpaySmartCollectData
  );
  return data;
};

const getPlanDuration = async () => {
  const data = await axios.get(
    `${config.api}/doubletick/plan/supported-durations`
  );
  return data.data;
};

const getStatesFromCountry = async country => {
  const { data } = await axios.get(
    `${config.api}/utils/country/states?countryCode=${country}`
  );
  return data;
};

const getQuotationRedirectUrl = async type => {
  const data = await axios.get(
    `${config.api}/internal/quotation/redirect-url?type=${type}`
  );
  return data.data;
};

export default {
  init,
  login,
  firebaseLogin,
  register,
  logout,
  addCompanyPayData,
  expireCompany,
  getPaidCompanyList,
  checkDomain,
  getCompanyMetaData,
  getCompanyIdDetails,
  getEstimate,
  generateLink,
  generateUpgradeLink,
  getSalesType,
  getSalesPersonEmail,
  getLinkValidityDetails,
  savePaymentLink,
  uploadCompanyLogo,
  setMandatoryLogin,
  getExperimentsData,
  setPaymentGatewayShown,
  setPrivacyModuleActive,
  setResellerGroupCreation,
  saveCompanyFeedback,
  getLastPayment,
  getNotificationKeyData,
  sendNotification,
  setGrtVendor,
  getCompanyIdFromRemote,
  getCompanyKycData,
  toggleVerifyCompanyKycData,
  getCompanyPitchFromRemote,
  validateRequestLead,
  assignMoreLeads,
  generateEmandateLink,
  getFilterDetails,
  downloadCatalogue,
  getCataloguesData,
  createChargebeeCustomer,
  getDoubleTickOrganizationDetails,
  getSecureLead,
  createRazorpaySmartCollectId,
  getPlanDuration,
  getStatesFromCountry,
  getQuotationRedirectUrl
};



// WEBPACK FOOTER //
// ./src/lib/api.js